<template>
  <div>
    <loader v-if="loading" label="Carregando contas..." />

    <form-group
      :columns="12"
      label="Conta"
      :required="true"
    >
      <select class="form-select" v-model="account" required>
        <option disabled value="">Selecione</option>
        <option
          v-for="account in tikTokShopAccounts"
          :key="account.identifier"
          :value="account.identifier"
        >
          {{ account.nickname }} 
        </option>
      </select>
    </form-group>

    <form-group
      :columns="12"
      label="Loja"
      :required="true"
    >
      <select class="form-select" v-model="selectedAuthorizedShop" required>
        <option disabled value="">Selecione</option>
        <option
          v-for="authorizedShop in authorizedShops"
          :key="authorizedShop.identifier"
          :value="authorizedShop.cipher"
        >
          {{ authorizedShop.nickname }} 
        </option>
      </select>
    </form-group>
  </div>
</template>

<script>
import api from '@/api'
import FormGroup from '@/components/template/FormGroup'
import Loader from '@/components/template/Loader'

export default {
  data: () => ({
    account: '',
    tikTokShopAccounts: [],
    authorizedShops: [],
    selectedAuthorizedShop: '',
    loading: false,
    submitted: false
  }),
  async mounted () {
    this.loading = true
    try {
      const { items } = await api.tikTokShop.getAccounts({})
      this.tikTokShopAccounts = items
      if (this.tikTokShopAccounts.length === 1) this.account = this.tikTokShopAccounts[0].identifier
    } finally {
      this.loading = false
    }
  },
  methods: {
    async syncOrder (data) {
      this.submitted = true
      if (!this.account || !this.selectedAuthorizedShop) {
        return
      }

      await api.tikTokShop.syncOrder(
        data.type,
        data.identifier,
        data.code,
        this.account,
        this.selectedAuthorizedShop
      )
    },
    async getAuthorizedShops () {
      this.loading = true
      try {
        this.authorizedShops = await api.tikTokShop.getAuthorizedShops(this.account)
        if (this.authorizedShops.length === 1) this.selectedAuthorizedShop = this.authorizedShops[0]
      } catch (_) {
        this.$notify.error({
          title: 'Erro',
          message: 'Não foi possível buscar as lojas autorizadas nesta conta.'
        })
        this.authorizedShops = []
      } finally {
        this.loading = false
      }
    }
  },
  watch: {
    async account (v) { if (v) await this.getAuthorizedShops() }
  },
  components: {
    FormGroup,
    Loader
  }
}
</script>



// WEBPACK FOOTER //
// SyncDialog.vue?21a391cd